import { ValueOfObject } from 'shared/utils/types';

export const ApiListOrder = Object.freeze({
  asc: 'asc',
  desc: 'desc'
} as const);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ApiListOrder = ValueOfObject<typeof ApiListOrder>;
